import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Test, Training } from '../app.urls';
import { LoaderService } from './loader.service';
@Injectable({
  providedIn: 'root',
})
export class TestService {
  public testID = new Subject<any>();
  public scheduleuuid = new Subject<any>();
  public loadItemGroups = new Subject<any>();

  private updateTestStatusSource = new BehaviorSubject<any>('');
  public updateTestStatus = this.updateTestStatusSource.asObservable();

  private newTest = new BehaviorSubject<any>('');
  public getNewtest = this.newTest.asObservable();


  private updatedTest = new BehaviorSubject<any>('');
  public getUpdatedTest = this.updatedTest.asObservable();

  public isTestItemCount = new BehaviorSubject<any>('');
  public TestItemCount = this.isTestItemCount.asObservable();
  public selectedSendInMain = new BehaviorSubject<any>(null);
  public styleGroup = new BehaviorSubject<any>('');
  public styleGroupList = this.styleGroup.asObservable();

  public testDetails = new BehaviorSubject<any>('');
  public getTestDetail = this.testDetails.asObservable();
  public listMode = new BehaviorSubject<any>(null);

  public ItemCategory = new BehaviorSubject<any>('');
  public getItemCategoryList = this.ItemCategory.asObservable();
  public testStatusList = new BehaviorSubject<any>('');
  public getTestStatusListt = this.testStatusList.asObservable();

  scheduleBackBtnobs = new BehaviorSubject<any>(false);

  schedulUuid: any;
  constructor(private http: HttpClient, private loaderService: LoaderService) { }

  updatedTestDetails(test: any) {
    this.updatedTest.next(test);
  }

  newTestList(test: any) {
    this.newTest.next(test);
  }

  updateStatus(isPublishedStatus: any): void {
    this.updateTestStatusSource.next(isPublishedStatus);
  }

  updateTestId(value: any) {
    this.testID.next(value);
  }

  getTestStatusList() {
    return this.http.get<any>(Test.TestStatusList);
  }

  getItemByTestId(testUUID: number) {
    return this.http.get<any>(Test.getItemByTestId + `${testUUID}`);
  }

  getTestDetails(testUUID: number) {
    return this.http.get<any>(Test.TestDetails + `${testUUID}` + Test.getTestDetailsEndUrl);
  }

  getTestTags(testId: number) {
    return this.http.get<any>(Test.TestDetails + `${testId}/tags`);
  }


  // this function is fetching time zones data from api
  getTimeZone(): Observable<any> | null {
    return this.http.get<any>(Test.TimeZone + 'gettimezonelist')
  }

  getTests(collectionuuId: string): Observable<any> | null {
    return this.http.get<any>(Test.GetTests + '?collectionuuId=' + collectionuuId)
  }

  getInstruction(data: any): Observable<any> | null {
    return this.http.get<any>(Test.ItemByTestId + `${data.testBankuuId}/settings/${data.itemBankuuId}`)
  }

  getTestItemFilter(item: any): Observable<any> | null {
    const fetchItemapiUrl =
      Test.TestItemFilter + '?collectionId=' + item.itemId + '&itemBankName=' + item.itemName + '&itemDescription=' + item.itemDescription + '&itemStatus' + item.itemStaus;
      return this.http.get<any>(fetchItemapiUrl)
  }

  getTestFilter(filterData: any): Observable<any> | null {
    const fetchTestApiUrl =
      Test.GetTests + '?collectionuuId=' + filterData.collectionuuId + '&testName=' + filterData.testName + '&testDescription=' + filterData.testDescription + '&tag=' + filterData.tag + '&testStatus=' + filterData.testStatus;

      return this.http.get<any>(fetchTestApiUrl)
  }

  createTest(dataToApi: any) {
    return this.http.post<any>(Test.CreateTest, dataToApi)
  }

  saveTestSettings(dataToApi: any, testuuId: number) {
    return this.http.put<any>(Test.TestDetails + testuuId + '/settings', JSON.stringify(dataToApi), { 'headers': { 'content-type': 'application/json' } })
  }

  addInstructions(dataToApi: any, testuuid: string) {
    return this.http.post<any>(Test.AddInstructions + testuuid, JSON.stringify(dataToApi), { 'headers': { 'content-type': 'application/json' } })
  }

  updateInstructions(dataToApi: any, testuuid: string, instructionid: any) {
    return this.http.put<any>(Test.AddInstructions + testuuid, JSON.stringify(dataToApi), { 'headers': { 'content-type': 'application/json' } })
  }

  updateTest(dataToApi: any, testuuId) {
    return this.http.put<any>(Test.TestDetails + testuuId, JSON.stringify(dataToApi), { 'headers': { 'content-type': 'application/json' } })
  }

  getAllTagsForItem(collectionuuId: any, testuuId: any, keyword: string) {
    if (typeof keyword !== 'string') {
      keyword = ' ';
    }
    const fetchTagsapiUrl = Test.getAllTagsForItem + '?collectionuuId=' + collectionuuId + '&testuuId=' + testuuId + '&keyword=' + keyword;
    // this.loaderService.sentReqUrl(fetchTagsapiUrl);

    return this.http.get<any>(fetchTagsapiUrl)
  }

  addTestTag(testId: number, tagId: number, tagOrder: any) {
    const dataToApi = {
      tagid: tagId,
    };
    return this.http.post<any>(Test.TestDetails + testId + '/tags', JSON.stringify(dataToApi),{ 'headers': { 'content-type': 'application/json' } })
  }

  deleteTagFromTest(testTagId: number) {
    return this.http.delete<any>(Test.DeleteTagFromTest + testTagId)
  }

  deleteInstruction(testuuid: string, instructionid: any) {
    return this.http.delete<any>(Test.ItemByTestId + testuuid + '/instruction/' + instructionid)
  }

  deleteItemFromTest(testBankuuId: number, itemBankuuId: number) {
    return this.http.delete<any>(Test.ItemByTestId + testBankuuId + '/items/' + itemBankuuId)
  }

  addItemToTest(testId: any, itemBankId: any, dataToApi: any) {
    return this.http.post<any>(Test.AddItemToTest + testId + '/composetest', JSON.stringify(dataToApi), { 'headers': { 'content-type': 'application/json' } })
  }

  addItemToTest1(testId: any, dataToApi: any) {
    return this.http.post<any>(Test.AddItemToTest + testId + '/composetest', JSON.stringify(dataToApi), { 'headers': { 'content-type': 'application/json' } })
  }

  addTestSchedule(testSchedule) {
    return this.http.post<any>(Test.TestSchedule, JSON.stringify(testSchedule), { 'headers': { 'content-type': 'application/json' } })
  }


  addTestSchedulePopup(testSchedule, body) {
    return this.http.post<any>(Test.TestSchedulePopup, JSON.stringify(testSchedule, body), { 'headers': { 'content-type': 'application/json' } })
  }


  getTestSchedule(collectionuuId, testuuId) {
    return this.http.get<any>(Test.GetTestSchedule + '?collectionuuId=' + collectionuuId + '&testuuId=' + testuuId)
  }

  getExamineetoSchedule() {
    return this.http.get<any>(Test.ExamineesSchedule)
  }

  getFilterExamineetoSchedule(value: any) {
    const fetchExamineeAPI = Test.ExamineesSchedule + '?searchKeyword=' + value
    return this.http.get<any>(fetchExamineeAPI);
  }

  editTestSchedule(scheduleuuId) {
    return this.http.get<any>(Test.editTestSchedule + scheduleuuId)
  }

  updateExamineeRecepient(testScheduleId, testId) {
    return this.http.get<any>(Test.updateExamineeRecepient + '?testuuId=' + testId + '&scheduleuuId=' + testScheduleId)
  }

  editTestScheduleForm(testSchedule) {
    return this.http.put<any>(Test.TestSchedule, JSON.stringify(testSchedule), { 'headers': { 'content-type': 'application/json' } })
  }


  scheduleFilter(collectionuuId, testuuId, filterObj) {
    const addTagApiUrl =
      Test.GetTestSchedule + '?collectionuuId=' + collectionuuId + '&testuuId=' + testuuId + '&fromDate=' + filterObj.fromDate + '&toDate=' + filterObj.todate + '&scheduleStaus=' + filterObj.scheduleStatus + '&type=' + filterObj.scheduleType + '&scheduleName=' + filterObj.scheduleName;
    return this.http.get<any>(addTagApiUrl)
  }

  cancleSchduel(scheduleId) {
    return this.http.delete<any>(Test.TimeZone + scheduleId)
  }

  getTestToltalScore(testId) {
    return this.http.get<any>(Test.TestDetails + testId + '/marks')
  }


  // --------PENDING--------

  deleteRecipient(recipientuuid) {
    return this.http.delete<any>(Test.DeleteRecipient + recipientuuid)
  }

  getRecipient(scheduleuuId, testuuid): Observable<any> {
    return this.http.get<any>(Test.Recipient + '?scheduleuuId=' + scheduleuuId + '&testuuId=' + testuuid)
  }

  getStyleGroups(globalcollectionuuId) {
    return this.http.get<any>(Test.getStyleList + '?collectionId=' + globalcollectionuuId);
  }

  getScoringTypes() {
    return this.http.get<any>(Test.getScoringType);
  }

  getLanguage() {
    return this.http.get<any>(Test.languageSettings);
  }

  deleteTest(testuuid) {
    return this.http.delete<any>(Test.deleteTest + testuuid);
  }

  videoTutorial(assetGroup) {
    return this.http.get<any>(Training.tutorial + assetGroup);
  }
}
